import type fr from '../fr/auth';

const en: typeof fr = {
  forgotLink: 'Forgot your password?',
  backToLogin: 'Back to sign in',
  passwordPolicy: 'At least {{min}} characters.',
  mismatch: 'The two passwords do not match.',
  forgot: {
    title: 'Forgot your password',
    subtitle: 'Enter your account email. We will send you a link to choose a new password.',
    email: 'Email',
    submit: 'Send the link',
    sentTitle: 'Check your email',
    sent: 'If an account exists for {{email}}, a reset link was just sent. It is valid for one hour. Remember to check your spam folder.',
  },
  reset: {
    title: 'New password',
    subtitle: 'Choose a new password for your account.',
    password: 'New password',
    confirm: 'Confirm password',
    submit: 'Save password',
    successTitle: 'Password changed',
    success: 'Your password was changed. You can now sign in.',
    goToLogin: 'Sign in',
    invalidTitle: 'Invalid or expired link',
    invalid: 'This reset link is no longer valid (it expired or was already used). Ask for a new one.',
    requestNew: 'Ask for a new link',
  },
  change: {
    title: 'Password',
    subtitle: 'For your security, your current password is required.',
    open: 'Change my password',
    current: 'Current password',
    next: 'New password',
    confirm: 'Confirm new password',
    submit: 'Update',
    cancel: 'Cancel',
    success: 'Your password was changed.',
    forgot: 'Forgot your current password?',
  },
  errors: {
    INVALID_RESET_TOKEN: 'This reset link is no longer valid. Ask for a new one.',
    WRONG_PASSWORD: 'The current password is incorrect.',
    SAME_PASSWORD: 'The new password must be different from the old one.',
    WEAK_PASSWORD: 'This password is too weak. Choose a longer or more varied one.',
    REAUTH_REQUIRED: 'For security reasons, sign out and sign in again before changing your password.',
    NO_LOCAL_PASSWORD: 'Your account uses an external sign-in: manage your password with the “Forgot your password?” link.',
    RATE_LIMITED: 'Too many attempts. Try again in a minute.',
    LOCAL_AUTH_DISABLED: 'This action is not available for this type of account.',
  },
};

export default en;
